import "@Styles/mandate.css";
import { initializeApp } from "firebase/app";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Modal from "react-modal";
import OtpInput from "react-otp-input";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "semantic-ui-react";
import {
  applyReferralCode,
  emailOtpVerify,
  sendBasicDetails,
} from "../../../../Redux/Authenticate/action";
import {
  emailVerify,
  getUserDetail,
} from "../../../../Redux/GeneralDetails/action";
import { getDocumentStatus } from "../../../../Redux/Manual_Kyc_Details/action";
import ToastMsg from "../../../../helper/ToastMsg";
import { recordEvent } from "../../../../utils/appFlyer";
import { trackCompleteRegistration } from "../../../../utils/metaPixel";
import { Loader } from "../../../NewUI/Common/Loader";
import Heading from "../../Common/MainHeading";
import { HEADING_EMAIL_VERIFYOTP } from "../../Common/constant";
import {trackEmailVerified} from "../../../../utils/ga4";

const optInput = {
  display: "inline",
  float: "left",
  width: "3.3rem",
  padding: "24px 20px",
  backgroundColor: "#FFFFFF",
  border: "none",
  borderRadius: 15,
  outline: "none",
  fontWeight: 600,
  textAlign: "center",
  redirect_url: "",
  font: "Roboto",
};

const VerifyOtpemail = (props) => {
  const navigate = useNavigate();
  const {
    isOpen,
    onRequestClose,
    email: emailProp,
    phone_number: phoneProp,
  } = props;

  const queryParams = new URLSearchParams(window.location.search);
  const email =
    emailProp || queryParams?.get("email") || localStorage.getItem("email");
  const phone_number =
    phoneProp ||
    queryParams?.get("phone_number") ||
    localStorage.getItem("phone_number");

  const [otp, setOtp] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loader, setLoader] = useState(false);
  const [inputBan, setInputBan] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);
  const [counter, setCounter] = useState(59);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const safeRedirect = (path) => {
    navigate(path);
  };

  const getErrorMessage = (err) => {
    if (!err) return "Something went wrong";
    const rdata = err.response?.data;
    return (
      rdata?.error ||
      rdata?.message ||
      rdata?.detail ||
      err.message ||
      "Something went wrong"
    );
  };

  const handleChange = useCallback((otpValue) => {
    setOtp(otpValue);
    if (otpValue?.length === 4) {
      createOnBoardUser(otpValue);
    }
  }, []);

  useEffect(() => {
    if (counter <= 0) return;
    const timer = setInterval(() => setCounter((c) => c - 1), 1000);
    return () => clearInterval(timer);
  }, [counter > 0]);

  const createOnBoardUser = async (otp_input) => {
    // Get email from props, query params, or localStorage
    const currentEmail = email || localStorage.getItem("email");
    const currentPhone = phone_number || localStorage.getItem("phone_number");

    if (!currentEmail) {
      ToastMsg("Email is required", "error");
      return;
    }

    try {
      setLoader(true);
      setInputBan(true);
      const receivedKey = localStorage.getItem("receivedKey");

      // Step 1: Verify email OTP
      const res = await props.emailOtpVerify({
        email: currentEmail,
        phone_number: Number(currentPhone),
        otp: otp_input,
        utm_campaign: localStorage.getItem("utm_campaign"),
        utm_source: localStorage.getItem("utm_source"),
        utm_medium: localStorage.getItem("utm_medium"),
        ...(receivedKey && { source: "pl-landing" }),
      });

      const token = res?.data?.data?.token;

      // Step 2: Record analytics event
      recordEvent({
        eventName: "email_verified",
        eventParams: { Platform: "web" },
      });

      // Step 3: Apply referral code if exists
      const referrer = localStorage.getItem("referrer");
      if (referrer) {
        await saveReferral(token, referrer);
      }

      // Step 4: Get user details
      const userRes = await props.getUserDetail(token);
      const userId = userRes?.data?.data?.id;

      const nv_data = userRes?.data?.data?.customusermodel;
      const user_data = {
        mobile: `+91${nv_data?.phone_number}`,
        email: userRes?.data?.data?.email,
        name: `${nv_data?.first_name} ${nv_data?.last_name}`,
      };
      nv("user", userId, user_data);

      trackCompleteRegistration({
        phone_number: currentPhone,
        registration_type: "email_otp",
        user_id: userId,
      });
      trackEmailVerified();
      nv("event", "email_verified", {
        user_id: userId,
        source: localStorage.getItem("utm_source") || document.referrer || "",
      }, "100", 1);
      // Step 5: Send AppsFlyer basic details
      await props.sendBasicDetails(token, userId);

      // Step 6: Get document status
      const docRes = await props.getDocumentStatus(token);
      setLoader(false);

      const docs = docRes && Array.isArray(docRes.data) ? docRes.data : [];
      const hasKarza = docs.some((d) => d && d.karza === true);

      // Step 7: Navigate based on status
      if (hasKarza) {
        safeRedirect("/karza");
      } else if (receivedKey) {
        safeRedirect("/creditlimit");
      } else {
        safeRedirect("/creditlimit");
      }
    } catch (err) {
      setLoader(false);
      if (err?.response?.status === 401) {
        window.location.href = "/";
        localStorage.removeItem("gpay_token");
        return;
      }
      if (!isButtonDisabled) {
        ToastMsg(getErrorMessage(err), "error");
        setIsButtonDisabled(true);
        setTimeout(() => {
          setInputBan(false);
          setIsButtonDisabled(false);
        }, 5000);
      }
    }
  };

  const handleResendOtp = useCallback(() => {
    setOtp("");
    setCounter(59);
    props
      .emailVerify({ phone_number, email })
      .then(() => ToastMsg("Otp sent successfully.", "success"))
      .catch((err) => {
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
      });
  }, [phone_number, email, props]);

  const saveReferral = async (token, referCode) => {
    const clickid = localStorage.getItem("clickid");
    const storedPartnerId = localStorage.getItem("partner_id");
    try {
      const res = await props.applyReferralCode(token, referCode, clickid, storedPartnerId || null);
      logEvent(analytics, "refferal_code_applied");
      return res;
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) {
        window.location.href = "/";
        localStorage.removeItem("gpay_token");
        throw err;
      }
      if (status === 406) {
        console.info("Referral code not applicable");
        return;
      }
      console.warn("applyReferralCode failed:", getErrorMessage(err));
    }
  };

  const isOtpComplete = otp?.length === 4;

  const OtpCard = useMemo(
    () => (
      <Form className="wholeContainer">
        <Form.Field className="mb-0">
          <span className="main__page font-size-18 ml-10" name="otp">
            Enter OTP
          </span>
          <div className="ml-10 mt-2">
            <span className="sendtoo">Sent to your Email ID</span>
          </div>
          <div className="otpFlex mt-25">
            <OtpInput
              containerStyle={`form-allign circle-otp${isOtpComplete ? " active" : ""}`}
              value={otp}
              onChange={handleChange}
              numInputs={4}
              inputType="number"
              renderSeparator={<span className="opacityzero">--</span>}
              renderInput={(inputProps) => (
                <input {...inputProps} style={optInput} disabled={inputBan} />
              )}
            />
          </div>
        </Form.Field>

        <Form.Field style={{ textAlign: "center", margin: "auto" }}>
          <div>
            <p
              className="receiveOTP dontreceiveOtp"
              style={{ height: "auto", marginBottom: "0" }}
            >
              Didn't receive OTP?
            </p>
            {counter === 0 ? (
              <a
                className="resendOtp textdecorUnderline mmb-gradient"
                onClick={handleResendOtp}
                style={{ cursor: "pointer" }}
              >
                Re-send
              </a>
            ) : (
              <a className="resendBtn">
                Re-send in 0:{counter < 10 ? `0${counter}` : counter}s
              </a>
            )}
          </div>
        </Form.Field>

        <div className="text-center">
          <button
            className="updatedbtnDesignotp GetotpSize"
            disabled={isButtonDisabled}
            onClick={() => createOnBoardUser(otp)}
          >
            Confirm
          </button>
        </div>
      </Form>
    ),
    [otp, isOtpComplete, inputBan, counter, isButtonDisabled, handleChange, handleResendOtp]
  );

  if (typeof isOpen === "boolean") {
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        className="otp-main-modal"
        overlayClassName="otp-main-overlay"
        ariaHideApp={false}
      >
        {loader ? <Loader /> : null}
        <div className="otp-main-content">
          <div className="otp-card">{OtpCard}</div>
        </div>
      </Modal>
    );
  }

  return (
    <>
      {isLargeScreen && (
        <div className="shadowlinepure  paddingLeftRight">
          <div className="ml-20">
            <Heading headingText={HEADING_EMAIL_VERIFYOTP} />
          </div>
        </div>
      )}
      <div className="toolbarRespo">
        {loader ? <Loader /> : null}
        <div className="pb-4">
          {!isLargeScreen && (
            <div className="shadowlinepure  paddingLeftRight">
              <div className="ml-20">
                <Heading headingText={HEADING_EMAIL_VERIFYOTP} />
              </div>
            </div>
          )}
          <div className="wrapper-content container flex">
            <div className="t px-4 pb-3 pt-1 w-100 text-center mx-auto ">
              <div className="h-100 d-flex flex-column justify-content-between">
                <div style={{ margin: "2px 0px 0px" }}>{/* image removed */}</div>
                {OtpCard}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps, {
  emailVerify,
  emailOtpVerify,
  getDocumentStatus,
  getUserDetail,
  applyReferralCode,
  sendBasicDetails,
})(VerifyOtpemail);
